export function GenrePage() { return <div><h1>Genre</h1><p className="muted">Bientôt.</p></div>; }
